import { FC } from "react";
import { Mindset as MindsetType } from "../../types/enums/Mindset";

import styles from "./styles.module.scss";

type Props = {
    mindset: MindsetType;
};

const Mindset: FC<Props> = ({ mindset }) => {
    const emoji = MindsetType[mindset as unknown as keyof typeof MindsetType];
    return <span className={styles.emoji}>{emoji}</span>;
};

export default Mindset;
